
import { compose, mdsWidget } from 'dojo/_base/declare';
import MultiSelect from '../../Multiselect/Multiselect';
//import DataItems = require("DataItems");

class MultiselectBox extends compose(MultiSelect) {
  // das Control macht selber nix mehr und wird zur Kompatbilität nur noch von Multiselect vererbt
}

export default mdsWidget(MultiselectBox);